<template>
    <v-form ref="form">
        <v-row  >
            <v-col cols="12" md="3" >
                <DatePicker 
                    :label="$t('date')"
                    outlined
                    dense
                    hide-details
                    clearable
                    v-model="form.date"
                    />
            </v-col>
            <v-col cols="6" md="3" class="">
                <v-text-field
                    :label="$t('reference')"
                    v-model="form.reference"
                    :rules="[isRequired]"
                    background-color="white" 
                    hide-details="auto" 
                    dense outlined>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row >
            <v-col cols="12" md="12">
                <div v-for="(line, index) in form.lines" :key="line.key">
                    <StockAdjustmentLine
                        v-model="form.lines[index]"
                        @delete-row="deleteRow(index)"
                        @update:item-search-input="searchItem"
                        :itemsLoading="itemsLoading"
                        :items="items"
                    />

                </div>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-btn block depressed small @click="addLine">
                    <v-icon left>mdi-playlist-plus</v-icon>
                    {{$t("add_new_line")}}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-textarea
                    :label="$t('remarks')"
                    v-model="form.remarks"
                    :rules="[isRequired]"
                    background-color="white"
                    outlined
                    hide-details="auto"
                    rows="4"
                    >
                </v-textarea>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import itemAPI from "./../../services/stockJournal/Item"  
import moment from 'moment';
import StockAdjustmentLine from './../../components/warehouse/StockAdjustmentLine'
import { isRequired } from './../../utils/validations';
import DatePicker from './../../components/common/DatePicker.vue'
export default {
    props: {
        value: Object
    },
    components: {
        DatePicker,
        StockAdjustmentLine
    },
    data() {
        return {
            isRequired,
            form: {
                reference: "",
                remarks: "",
                lines: [],
                date: moment().format("YYYY-MM-DD"),

            },
            line: {
                item_id: null,
                quantity: null,
                measure_unit_id: null,
                unit_value: null,
                total_value: null,
                account_id: null,
                dimension_id: null,
                base_quantity: this.quantity
            },
            items: [],
            itemsLoading: false
        }
    },
    watch:{
        form: {
            handler(form){
                this.$emit('input',form);
            },
            deep: true
        },
    },
    methods: {
        addLine() {
            this.form.lines.push({...this.line, key: Math.random()})
        },
        deleteRow(index) {
            this.form.lines.splice(index, 1);
        },
        fill() {
            let form = {...this.form, ...this.value};
            if(this.value.lines && Array.isArray(this.value.lines)) {
                form = {...form, lines: [...form.lines]}
            }
            this.form = form;
        },
        validate() {
            return this.$refs.form.validate()
        },
        searchItem(query) {
            this.itemsLoading = true

            itemAPI.search(query).then(res => 
                this.items = [...this.items, ...res.data]
            ).finally(() => {
                this.itemsLoading = false
            })
        }
    },
    mounted() {
        if(this.value) {
            this.fill();
            }
        },
    created() {
        this.addLine()
        if(this.value.lines){
            this.value.lines.forEach(line => this.items.push(line.item))
        }
    }
}
</script>

<style>

</style>